export default __webpack_public_path__ + "static/media/gallery-grid-img-2.e0689ff1.jpg";